import React, { useEffect, useRef, useState } from "react";
import caseStudyContent from "../data/caseStudyContent";

const SECTION_LABELS = [
  "Overview",
  "Background",
  "Problems",
  "Design",
  "Solutions",
  "Outcome",
];

function Paragraphs({ text }) {
  if (!text) return null;
  return (
    <>
      {text
        .split("\n\n")
        .filter((p) => p.trim())
        .map((p, i) => (
          <div
            className="prose"
            style={{ marginBottom: 12 }}
            key={i}
            dangerouslySetInnerHTML={{ __html: p.replace(/\n/g, "<br />") }}
          />
        ))}
    </>
  );
}

function Cards3({ items }) {
  if (!items || !items.length) return null;
  return (
    <div className="g3">
      {items.map((x, i) => (
        <div className="card" key={i}>
          {x.l && <div className="clbl">{x.l}</div>}
          <div className="ctit">{x.t}</div>
          <div className="cbod">{x.b}</div>
        </div>
      ))}
    </div>
  );
}

function Cards1({ items }) {
  if (!items || !items.length) return null;
  return (
    <div className="g1">
      {items.map((x, i) => (
        <div className="card1" key={i}>
          <div className="g1-title">
            {x.l && <div className="clbl">{x.l}</div>}
            <span>
              <div className="ctit">{x.t}</div>
              <div className="cbod">{x.b}</div>
            </span>
          </div>
        </div>
      ))}
    </div>
  );
}

function Prose3({ items }) {
  if (!items || !items.length) return null;
  return (
    <div className="g3t">
      {items.map((x, i) => (
        <div key={i}>
          {x.l && <div className="clbl">{x.l}</div>}
          <div className="ctit">{x.t}</div>
          <div className="cbod">{x.b}</div>
        </div>
      ))}
    </div>
  );
}
function MetricsGrid({ metrics }) {
  if (!metrics || !metrics.length) return null;
  return (
    <>
      <div className="mr">
        {metrics.map((m, i) => (
          <div className="met" key={i}>
            <div className="mn">{m.n}</div>
            <div className="ml">{m.l}</div>
          </div>
        ))}
      </div>
      <div style={{ height: 16 }} />
    </>
  );
}

function SolutionsList({ items }) {
  if (!items || !items.length) return null;
  return items.map((sl, i) => {
    // const flip = i % 2 === 1;
    const img = sl.img ? (
      <div className="simg">
        <img src={sl.img} alt="solution image" className="proj-solution-img" />
      </div>
    ) : null;
    const txt = (
      <div>
        <div className="clbl">{sl.l}</div>
        <div className="ctit">{sl.t}</div>
        <div className="prose">{sl.b}</div>
      </div>
    );
    return (
      <React.Fragment key={i}>
        <div className="g2">
          {img}
          {txt}
        </div>
        <div style={{ height: 12 }} />
      </React.Fragment>
    );
  });
}

function CaseStudyView({
  companies,
  ci,
  pi,
  onBack,
  onNavigate,
  onOpenCaseStudy,
}) {
  const co = companies[ci];
  const p = co.projects[pi];
  const s = caseStudyContent[`c${ci}p${pi}`] || {};

  const [activeSection, setActiveSection] = useState(0);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const sectionRefs = useRef([]);

  // Flat list of every project across every company, in display order, so
  // we can compute the prev/next footer links.
  const all = [];
  companies.forEach((c, i) => {
    c.projects.forEach((pr, j) => all.push({ ci: i, pi: j, title: pr.title }));
  });
  const cur = all.findIndex((x) => x.ci === ci && x.pi === pi);
  const prev = cur > 0 ? all[cur - 1] : null;
  const next = cur < all.length - 1 ? all[cur + 1] : null;

  useEffect(() => {
    window.scrollTo({ top: 0 });
    setActiveSection(0);
    setMobileMenuOpen(false);
  }, [ci, pi]);

  useEffect(() => {
    function handleScroll() {
      let cur = 0;
      sectionRefs.current.forEach((el, i) => {
        if (el && el.getBoundingClientRect().top < window.innerHeight * 0.45)
          cur = i;
      });
      setActiveSection(cur);
    }
    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, [ci, pi]);

  function goToSection(i) {
    setMobileMenuOpen(false);
    const el = sectionRefs.current[i];
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  const pills = companies.map((c, i) => (
    <button
      key={c.id}
      className={"pill" + (i === ci ? " act" : "")}
      onClick={() => onOpenCaseStudy(i, 0)}
    >
      {c.short}
    </button>
  ));

  return (
    <div id="page-cs">
      <div className="cs-mob-bar" style={{ position: "relative" }}>
        <button
          id="cs-mob-back"
          style={{ fontSize: 11, color: "#999" }}
          onClick={onBack}
        >
          ← Back
        </button>
        <span
          id="cs-mob-title"
          style={{ fontSize: 12, fontWeight: 500, color: "#1a1a1a" }}
        >
          {p.title}
        </span>
        <button
          id="cs-mob-ham"
          style={{ fontSize: 20, color: "#999", lineHeight: 1 }}
          onClick={() => setMobileMenuOpen((v) => !v)}
        >
          ≡
        </button>
        <div
          id="cs-mob-menu"
          className={"cs-mob-menu" + (mobileMenuOpen ? "" : " hide")}
        >
          {SECTION_LABELS.map((label, i) => (
            <span
              key={label}
              className={"cs-mob-mi" + (i === activeSection ? " act" : "")}
              onClick={() => goToSection(i)}
            >
              {label}
            </span>
          ))}
        </div>
      </div>

      <div className="cs-content-wrap">
        <div className="cs-sb">
          <div className="cs-back" onClick={onBack}>
            ← All work
          </div>
          {/* <div className="cs-co-lbl">{co.name}</div> */}
          <div className="cs-sline" />
          {/* <div className="cs-slbl">On this page</div> */}
          <div className="bc-rail">
            {SECTION_LABELS.map((label, i) => (
              <span
                key={label}
                className={
                  "bci" +
                  (i === activeSection
                    ? " act"
                    : i < activeSection
                    ? " vis"
                    : "")
                }
                onClick={() => goToSection(i)}
              >
                {label}
              </span>
            ))}
          </div>
          <div
            className="cs-up"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          >
            ↑ Top
          </div>
          <div
            className="sb-nav"
            style={{
              marginTop: "auto",
              paddingTop: 14,
              display: "flex",
              flexDirection: "column",
              gap: 2,
            }}
          >
            <div className="sb-nav-link" onClick={() => onNavigate("about")}>
              About me
            </div>
            {/* <div className="sb-nav-link" onClick={() => onNavigate("contact")}>
              Contact <span style={{ fontSize: 10, color: "#333" }}>↗</span>
            </div> */}
            <div className={"sb-nav-link"}>
              <a
                className="sb-ext-link"
                href="/BrannKhattiyanont_Resume.pdf"
                target="_blank"
              >
                Resume ↓
              </a>
            </div>
            <div className="sb-footer">
              <p>©2026 Bannawit Khattiyanont</p>
            </div>
          </div>
        </div>

        <div className="cs-main" id="cs-content">
          <div ref={(el) => (sectionRefs.current[0] = el)}>
            <div className="cs-header">
              <h1 className="cs-pname">{p.title}</h1>
              {/* <p className="cs-rt">{(p.rt || "6 min") + " read"}</p> */}
            </div>
            <div className="ey">Background</div>
            <div className="sec">
              <div className="sec-l">
                <div className="sh">
                  {s.overviewTitle || "What this project is about"}
                </div>
                <Paragraphs text={s.overview || p.desc} />
                <Cards3 items={s.overviewCards} />
                <div className="sh">
                  {s.backgroundTitle || "How we got here"}
                </div>
                <Paragraphs text={s.backgroundProse} />
                <Prose3 items={s.background} />
              </div>
              <div className="sec-r">
                <img
                  className="cs-banner"
                  src={s.introImage}
                  style={{ width: s.introwidth }}
                  alt=""
                />
              </div>
            </div>
          </div>

          <div className="ey">Problems</div>
          <div className="sec" ref={(el) => (sectionRefs.current[2] = el)}>
            <div className="sec-l">
              <div className="sh">
                {s.problemsTitle || "What we were solving"}
              </div>
              <Paragraphs text={s.problemsProse} />
              {s.quote && (
                <div className="pq">
                  <div className="pqt">{s.quote}</div>
                  {s.quoteAttr && <div className="pqa">{s.quoteAttr}</div>}
                </div>
              )}
            </div>
            <div className="sec-r">
              {/* <div className="fi">
                <span>Diagram / annotated screenshot</span>
              </div> */}
              <Cards1 items={s.problems} />
            </div>
          </div>

          <div className="ey">Design</div>
          <div
            className="sec"
            style={{ display: "block" }}
            ref={(el) => (sectionRefs.current[3] = el)}
          >
            <div className="sh">{s.designTitle || "How we approached it"}</div>
            <Paragraphs text={s.designProse} />
            <Cards3 items={s.design} />

            <div className="fi">
              {[1, 2, 3, 4].map((n) => {
                const src = s[`progimg${n}`];
                if (!src) return null;
                const locked = s[`prodLocked${n}`];
                return (
                  <div
                    key={n}
                    className={
                      "proj-product-wrap" + (locked ? " is-locked" : "")
                    }
                  >
                    <img
                      src={src}
                      alt="project-image"
                      className="proj-product-img"
                      style={{
                        display: s[`prodImgShow${n}`],
                        width: s[`prodWidth${n}`],
                      }}
                    />
                    {locked && (
                      <div className="proj-locked-overlay">
                        <svg
                          className="proj-locked-icon"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#1a1a1a"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <rect x="5" y="11" width="14" height="10" rx="2" />
                          <path d="M8 11V7a4 4 0 0 1 8 0v4" />
                        </svg>
                        <div className="proj-locked-text">
                          Contact Brann for more information
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>

            <Paragraphs text={s.designProse2} />
          </div>

          <div className="ey">Solutions</div>
          <div
            className="sec"
            style={{ display: "block" }}
            ref={(el) => (sectionRefs.current[4] = el)}
          >
            <div className="sh">{s.solutionsTitle || "What we built"}</div>
            <SolutionsList items={s.solutions} />
          </div>

          <div className="ey">Outcome</div>
          <div
            className="sec"
            style={{ display: "block" }}
            ref={(el) => (sectionRefs.current[5] = el)}
          >
            <div className="sh">{s.outcomeTitle || "What changed"}</div>
            <MetricsGrid metrics={p.metrics} />

            <Paragraphs
              text={
                s.outcome ||
                p.outcome ||
                "The project delivered measurable impact and established a foundation for future improvements."
              }
            />
            <Cards1 items={s.outcomes} />
          </div>

          <div className="ft">
            {/* <div className="ftlbl">Continue exploring</div> */}
            <div className="ftrow">
              {prev ? (
                <button
                  className="fc"
                  onClick={() => onOpenCaseStudy(prev.ci, prev.pi)}
                >
                  {/* <div className="ftmb">
                    <span>Prev</span>
                  </div> */}
                  <div>
                    <div className="fdir">← Previous</div>
                    <div className="fnm">{prev.title}</div>
                  </div>
                </button>
              ) : (
                <div />
              )}
              <div className="fmid">
                <div className="fmidlbl">Switch company</div>
                <div className="pills">{pills}</div>
              </div>
              {next ? (
                <button
                  className="fc fcnext"
                  onClick={() => onOpenCaseStudy(next.ci, next.pi)}
                >
                  <div style={{ textAlign: "right" }}>
                    <div className="fdir">Next →</div>
                    <div className="fnm">{next.title}</div>
                  </div>
                  {/* <div className="ftmb">
                    <span>Next</span>
                  </div> */}
                </button>
              ) : (
                <div />
              )}
            </div>
            <div className="ft-mob-co">
              <div className="fmidlbl">Switch company</div>
              <div className="pills">{pills}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CaseStudyView;
